import MDLAbstract from "../MDLAbstract";
import HTTP from "../../HTTP";
import Config from "../../Config";
import MDL from "..";

export default class checklist extends MDLAbstract<any> {

    getChecklistLista = async () => {
        try {
            const response = await HTTP.GET({ url: Config.apis.api_checklist + "/checklist/checklist_lista", });
            if (!response || response.length <= 0) return null
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    getChecklistTiposVehiculos = async () => {
        try {
            const response = await HTTP.GET({ url: Config.apis.api_checklist + "/checklist/checklist_tipos_vehiculos", });
            if (!response || response.length <= 0) return null
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    getChecklistChoferes = async () => {
        try {
            const response = await HTTP.GET({ url: Config.apis.api_checklist + "/checklist/checklist_choferes", });
            if (!response || response.length <= 0) return null
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    getChecklistVehiculos = async () => {
        try {
            const response = await HTTP.GET({ url: Config.apis.api_checklist + "/checklist/checklist_vehiculos", });
            if (!response || response.length <= 0) return null
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    getChecklistLogin = async (params: { dni: string, matricula: string }) => {
        try {
            const dni = String(params?.dni ?? "").trim();
            const matricula = String(params?.matricula ?? "").trim();
            if (!dni || !matricula) {
                throw "El dni y la matricula son obligatorios";
            }
            const response = await HTTP.GET({ url: `${Config.apis.api_checklist}/checklist/checklist_login?dni=${encodeURIComponent(dni)}&matricula=${encodeURIComponent(matricula)}`, });
            return response as any;
        } catch (error: any) {
            throw error?.message ?? error;
        }
    }

    getChecklistRegistros = async (dni: string, matricula: string) => {
        try {
            const dniStr = String(dni ?? "").trim();
            const matriculaStr = String(matricula ?? "").trim();
            if (!dniStr || !matriculaStr) {
                throw "El dni y la matricula son obligatorios";
            }
            const response = await HTTP.GET({ url: `${Config.apis.api_checklist}/checklist/checklist_registros?dni=${encodeURIComponent(dniStr)}&matricula=${encodeURIComponent(matriculaStr)}`, });
            if (!response || response.length <= 0) return null;
            return response as any;
        } catch (error: any) {
            throw error?.message ?? error;
        }
    }

    postChecklistLista = async (body: any) => {
        try {
            const response = await HTTP.POST({
                url: Config.apis.api_checklist + "/checklist/checklist_lista",
                body,
            });
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    putChecklistListaUpdate = async (body: any) => {
        try {
            const response = await HTTP.PUT({
                url: Config.apis.api_checklist + "/checklist/checklist_lista/update",
                body,
            });
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }
    getChecklistPregunta = async () => {
        try {
            const response = await HTTP.GET({ url: Config.apis.api_checklist + "/checklist/checklist_pregunta", });
            if (!response || response.length <= 0) return null

            const filtered = (Array.isArray(response) ? response : []).filter((item: any) => {
                return item?.tipo_pregunta !== "photo";
            })
            console.clear();
            console.log("%c" + JSON.stringify(response), `color: #2ECC40; font-weight: bold;`);

            return filtered as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    getChecklistFotos = async () => {
        try {
            const response = await HTTP.GET({ url: Config.apis.api_checklist + "/checklist/checklist_pregunta", });
            if (!response || response.length <= 0) return null
            const filtered = (Array.isArray(response) ? response : []).filter((item: any) => {
                return item?.tipo_pregunta === "photo";
            });
            return filtered as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    getChecklistFoto = async () => {
        return this.getChecklistFotos();
    }

    getChecklistRepoFotos = async () => {
        try {
            const response = await HTTP.GET({ url: Config.apis.api_checklist + "/checklist/repo", });
            if (!response || response.length <= 0) return null
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    postChecklistPregunta = async (body: any) => {
        try {
            const response = await HTTP.POST({ url: Config.apis.api_checklist + "/checklist/checklist_pregunta", body, });
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    putChecklistPreguntaUpdate = async (body: any) => {
        try {
            const response = await HTTP.PUT({ url: Config.apis.api_checklist + "/checklist/checklist_pregunta/update", body, });
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    getChecklistDetalle = async () => {
        try {
            const response = await HTTP.GET({ url: Config.apis.api_checklist + "/checklist/checklist_detalle", });
            if (!response || response.length <= 0) return null
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    postChecklistDetalle = async (body: any) => {
        try {
            const response = await HTTP.POST({ url: Config.apis.api_checklist + "/checklist/checklist_detalle", body, });
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    postChecklistFoto = async (params: { checklist_id: string, checklist_pregunta_id: string, file: any }) => {
        try {
            const checklist_id = String(params?.checklist_id || "").trim();
            if (!checklist_id) {
                throw "El checklist_id es obligatorio";
            }
            const checklist_pregunta_id = String(params?.checklist_pregunta_id || "").trim();
            if (!checklist_pregunta_id) {
                throw "El checklist_pregunta_id es obligatorio";
            }
            const formData = new FormData();
            formData.append("checklist_id", checklist_id);
            formData.append("checklist_pregunta_id", checklist_pregunta_id);
            if (params?.file?.file) {
                formData.append("file", params.file.file);
            } else {
                formData.append("file", {
                    uri: params?.file?.uri,
                    name: params?.file?.name || "foto.jpg",
                    type: params?.file?.type || "image/jpeg",
                } as any);
            }
            const response = await HTTP.POST_FORMDATA({ url: Config.apis.api_checklist + "/checklist/post_checklist_fotos", body: formData, });
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    putChecklistDetalleUpdate = async (body: any) => {
        try {
            const response = await HTTP.PUT({ url: Config.apis.api_checklist + "/checklist/checklist_detalle/update", body, });
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }

    getChecklistMatriculaDetalle = async (matricula: string) => {
        try {
            const matriculaStr = String(matricula ?? "").trim();
            if (!matriculaStr) {
                throw "La matrícula es obligatoria";
            }
            const response = await HTTP.GET({ url: `${Config.apis.api_checklist}/checklist/checklist_getmatriculadetalle?matricula=${encodeURIComponent(matriculaStr)}`, });
            if (!response || response.length <= 0) return null;
            return response as any;
        } catch (error: any) {
            throw error?.message ?? error;
        }
    }

    getChecklistTipoVehiculo = async (matricula: string) => {
        try {
            const matriculaStr = String(matricula ?? "").trim();
            if (!matriculaStr) {
                throw "La matrícula es obligatoria";
            }
            const response = await HTTP.GET({ url: `${Config.apis.api_checklist}/checklist/checklist_getipovehicula?matricula=${encodeURIComponent(matriculaStr)}`, });
            if (!response || response.length <= 0) return null;
            return response as any;
        } catch (error: any) {
            throw error?.message ?? error;
        }
    }

    getMatriculasActivas = async () => {
        const plate = MDL.usuario.session?.plate ?? "";
        const lc: any = await MDL.checklist.getChecklistLogin({
            dni: MDL.usuario.session?.sDNI ?? "",
            matricula: plate,
        });
        if (Array.isArray(lc)) {
            if (lc.length <= 0) {
                throw "No se encontro expediciones para el chofer";
            }
        }
        console.log("lc", lc);
        let tipo_vehiculo = JSON.parse(lc?.tipo_vehiculo ?? "{}");
        const matriculas: any = {};
        matriculas[plate] = {
            plate: plate,
            descripcion: tipo_vehiculo.sTipo,
            tipo_vehiculo_id: tipo_vehiculo.lTipoVehiculo_id + "",
        }
        if (lc.expediciones) {
            lc.expediciones.forEach((expedicion: any) => {
                const plate = expedicion.sRemolque;
                if (!matriculas[plate]) {
                    matriculas[plate] = {
                        plate: plate,
                        descripcion: expedicion.sTipo,
                        tipo_vehiculo_id: expedicion.lTipoVehiculo_id + "",
                    }
                }
            })
        }
        return matriculas;
    }

    getRecientes = async (matriculas: any[]) => {
        try {
            const body = { matriculas: matriculas, dni: MDL.usuario?.session?.sDNI ?? "" };
            const response = await HTTP.POST({ url: Config.apis.api_checklist + "/checklist/get_recientes", body, });
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }
    crearChecklist = async (data: any) => {
        try {
            const response = await HTTP.POST({ url: Config.apis.api_checklist + "/checklist/checklist", body: data, });
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }
    completado = async (data: any) => {
        try {
            const response = await HTTP.PUT({ url: Config.apis.api_checklist + "/checklist/completado", body: data, });
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }
    setChecklistDetalle = async (data = { id_pregunta: "", id_checklist: "", value: "", url_path: "" }) => {
        try {
            const response = await HTTP.POST({ url: Config.apis.api_checklist + "/checklist/set_checklist_detalle", body: data, });
            return response as any;
        } catch (error: any) {
            throw error?.message
        }
    }
    getCompleto = async (id: string) => {
        try {
            // const body = { id: id };
            const response = await HTTP.GET({ url: Config.apis.api_checklist + "/checklist/get_checklist_completo/" + id, });
            return response as any;
        } catch (error: any) {
            console.error("Error en getCompleto:", error);
            // throw error?.message
        }
    }
    __loginChofer = async (data: { dni: string, matricula: string }) => {
        if (!data.dni) throw "El dni es requerido";
        try {
            const response: any = await MDL.checklist.getChecklistLogin({ dni: data.dni, matricula: data.matricula });

            if (!response) {
                throw "No se encontro chofer con el DNI y matricula enviados";
            }

            const tipoVehiculoId = String(response?.tipo_vehiculo_id ?? '1000').trim();

            const parseExpediciones = async () => {
                const exp = response?.expediciones;
                if (!exp) return [];
                // El backend ya devuelve expediciones parseado, pero por si acaso validamos
                const expediciones = Array.isArray(exp) ? exp : [];
                // Obtener tipo_vehiculo_id para cada expedición usando el sRemolque
                return Promise.all(expediciones.map(async (e) => {
                    try {
                        const infoVehiculo: any = await MDL.checklist.getChecklistTipoVehiculo(e.sRemolque);
                        const tipoVehiculoIdRemolque = infoVehiculo?.[0]?.tipo_vehiculo_id ?? tipoVehiculoId;
                        const sModelo = infoVehiculo?.[0]?.sModelo ?? '';
                        const descripcion = infoVehiculo?.[0]?.descripcion ?? '';
                        return {
                            ...e,
                            tipo_vehiculo_id: String(tipoVehiculoIdRemolque).trim(),
                            sModelo: String(sModelo).trim(),
                            descripcion: String(descripcion).trim()
                        };
                    } catch (error) {
                        // Si hay error, usar el tipo_vehiculo_id del chofer
                        return {
                            ...e,
                            tipo_vehiculo_id: tipoVehiculoId,
                            sModelo: ''
                        };
                    }
                }));
            };

            const infoTractor: any = await MDL.checklist.getChecklistTipoVehiculo(response?.plate);

            const user: any = {
                sDNI: String(response?.sDNI ?? data.dni).trim(),
                sNombreChofer: String(response?.sNombreChofer ?? '').trim(),
                plate: String(response?.plate ?? response?.sMatricula ?? data.matricula).trim(),
                tipo_vehiculo_id: String(infoTractor?.[0]?.tipo_vehiculo_id ?? tipoVehiculoId).trim(),
                sModelo: String(infoTractor?.[0]?.sModelo ?? '').trim(),
                descripcion: String(infoTractor?.[0]?.descripcion ?? '').trim(),
                expediciones: await parseExpediciones(),
                ...(response?.iEstado !== undefined && { iEstado: response.iEstado }),
                ...(response?.lChofer_id && { lChofer_id: response.lChofer_id }),
            };

            return user;
        } catch (error: any) {
            throw error?.message ?? error?.detail ?? "Error al iniciar sesion"
        }
    }


    // Compatibilidad con llamadas existentes
    getAllPreguntas = async () => {
        return this.getChecklistPregunta();
    }
}

// aqui todos los MDL
// etiene que logear dandole permiso a un usuario
// pero nosotors logeamos solo con dni y matricula tractora

// MATICULA 1419-JVS
// DNI 18536035J